/*
 *   File : list.js
 *   Author URI : https://evoqins.com
 *   Description : Page to list HUF. 
 *   Integrations : null
 *   Version : v1.1
 */

// packages
import { Fragment, useEffect, useState } from "react";
import { NavigationHeader } from "../../../Components/Header";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

// components
import Colors from "../../../Styles/color.module.scss";
import { Icon } from "../../../Components/Icon";
import { DataTableContainer } from "../../../Components/FormElements";
import { useNavigate } from "react-router-dom";
import { GradientButton, LinkText } from "../../../Components/Cta";
import { CustomLoader, EmptyScreen } from "../../../Components/Other";
import { OnboardingCheckModal, ViewDocModal } from "../../../Components/Modal";
import { CustomTab } from "../../../Components/Tab";

// services
import APIService from "../../../Services/api-service";


const TABLE_STYLE = {
    table: {
        style: {
            padding: "12px 16px 16px 16px",
            background: Colors.white,
        },
    },
    tableBody: {
        style: {
            margin: '0px',
            marginTop: "0px !important"
        }
    },
    headRow: {
        style: {
            background: 'transparent',
            borderRadius: "16px 16px 0px 0px",
            border: "0",
            borderBottom: `1px solid ${Colors.bright_gray} !important`,
            fontSize: "14px",
            fontFamily: "Poppins-Medium",
            lineHeight: "24px",
            color: Colors.outer_space
        }
    },
    rows: {
        style: {
            margin: "0",
            background: "transparent",
            border: `1px solid ${Colors.bright_gray} !important`,
            borderRadius: "16px",
            marginTop: "14px",
            fontSize: "16px",
            fontFamily: "Poppins-Regular",
            lineHeight: "24px",
        },
    },
    cells: {
        style: {
            cursor: "pointer",
            '&:not(:last-child)': {
                paddingLeft: '0px',
                paddingRight: '0px',
                display: 'flex',
            },
            '&:first-child': {
                padding: "24px 0px 24px 24px",
            }
        },
    },
    headCells: {
        style: {
            '&:not(:last-child)': {
                paddingLeft: '0px',
                paddingRight: '0px',
                display: 'flex',
            },
            '&:first-child': {
                padding: "24px 0px 24px 24px",
            }
        },
    },
    pagination: {
        style: {
            borderTop: `none `,
            color: Colors.outer_space,
            fontSize: '16px',
            fontFamily: "Poppins-Regular",
        },
    }
}



const HUFList = () => {
    const navigate = useNavigate();
    const [selectAll, setSelectAll] = useState(false);
    const [rowSelectFalse, setRowSelectFalse] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState(new Set());
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(null);
    const [pageSize, setPageSize] = useState(20);
    const [onboardingData, setOnboardingData] = useState({});
    const [apiLoader, setApiLoader] = useState(true);
    const [onboardingCheck, setOnboardingCheck] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [btnLoader, setBtnLoader] = useState(false);
    const [statusData, setStatusData] = useState({});
    const [selectedType, setSelectedType] = useState(null);
    const [kycTypes, setKycTypes] = useState([]);
    const [filterLoader, setFilterLoader] = useState(false);
    const [documentData, setDocumentData] = useState(null);

    // for deselecting header checkbox in the table
    useEffect(() => {
        if (rowSelectFalse === true) {
            setSelectAll(false);
        }
    }, [rowSelectFalse]);

    useEffect(() => {
        _kycFilterData();
    }, []);

    useEffect(() => {
        if (filterLoader === true) {
            _listOnboardingTypes();
        }
    }, [selectedType, filterLoader]);

    useEffect(() => {
        if (onboardingCheck !== null) {
            const modal = new Modal(document.getElementById("onboarding-check"));
            modal.show();
        }
    }, [onboardingCheck]);

    useEffect(() => {
        if (documentData !== null) {
            const modal = new Modal(document.getElementById("view-doc"));
            modal.show();
        }
    }, [documentData]);

    useEffect(() => {
        if (selectAll === true) {
            const customer_id_set = new Set(onboardingData.data.map((item) => item.id));
            setSelectedUsers((prevSet) => new Set([...prevSet, ...customer_id_set]));
            setRowSelectFalse(false);
        }
        else {
            if (rowSelectFalse === false) {
                setSelectedUsers(new Set());
            }
        }
    }, [selectAll, onboardingData.data]);

    const _handleRowCheckBox = (row, event) => {
        // console.log("Row", row);
        event.stopPropagation();
        // console.log("before", selectedUsers)
        if (selectedUsers.has(row.id)) {
            setSelectedUsers((prevCustomerIds) => {
                const new_customer_ids = new Set(prevCustomerIds);
                new_customer_ids.delete(row.id);
                return new_customer_ids;
            });
        }
        else {
            setSelectedUsers((prevCustomerIds) => new Set([...prevCustomerIds, row.id]));
        }
        setRowSelectFalse(true);
    }

    const _navigateToDetail = (id) => {
        if (id !== null) {
            navigate("detail", {
                state: {
                    customer_id: id
                }
            });
        }
    }

    const _handleSelectAll = (event) => {
        event.stopPropagation();
        setSelectAll(!selectAll)
    }

    // handler for page change
    function _nextPage() {
        setPageNumber(prevCount => prevCount + 1);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    // got to previous page
    function _previousPage() {
        setPageNumber(prevCount => prevCount - 1);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const ONBOARDING_COLUMNS = [

        {
            name: <div className={`position-relative w-fit-content`}>
                <Icon icon={selectAll === true ? "checked" : "unchecked"}
                    size={22}
                    className="position-absolute left-10 cursor-pointer d-none"
                    onClick={(event) => _handleSelectAll(event)} />

                <p className="mb-0">Customer. ID</p>
            </div>,
            selector: row => row['admin_id'],
            sortable: false,
            left: true,
            // width: "576px",
            width: "200px",
            // cell: row => <p className="color-outer-space e-poppins-regular e-font-16 mb-0">{row['admin_id']}</p>
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2">
                    <Icon icon={selectedUsers.has(row['id']) ? "checked" : "unchecked"}
                        size={22}
                        className="cursor-pointer d-none"
                        onClick={(event) => _handleRowCheckBox(row, event)} />
                    {/* {
                        row.aof ?
                            <LinkText title="View & download document"
                                onClick={() => window.open(row.aof)} />
                            :
                            "-"
                    } */}
                    <p className={`${row['mt_client_id'] !== null ? 'color-primary-color cursor-pointer' : 'color-outer-space'} e-poppins-regular e-font-16 mb-0`}
                        onClick={() => _navigateToDetail(row['customer_id'])}>{row['mt_client_id'] ? row['mt_client_id'] : '-'}</p>
                    {/* <p className="color-outer-space e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['admin_id']}</p> */}
                </div>
        },
        {
            name: 'Name',
            selector: row => row['name'],
            sortable: false,
            left: true,
            width: "220px",
            cell: row => <p className="color-outer-space e-poppins-regular e-font-16 mb-0">{row['name']}</p>
        },
        {
            name: 'PAN number',
            selector: row => row['pan'],
            sortable: false,
            left: true,
            width: "160px",
            cell: row => <p className="color-outer-space e-poppins-regular e-font-16 mb-0">{row.pan ? row.pan : "-"}</p>
        },
        {
            name: 'Email',
            selector: row => row['email'],
            sortable: false,
            left: true,
            width: "200px",
            cell: row => <p className="color-outer-space e-poppins-regular e-font-16 mb-0">{row['email']}</p>
        },
        {
            name: 'Phone',
            selector: row => row['mobile'],
            sortable: false,
            left: true,
            width: "160px",
            cell: row => <p className="color-outer-space e-poppins-regular e-font-16 mb-0">{row['mobile']}</p>
        },
        {
            name: 'AOF',
            sortable: false,
            left: true,
            width: "240px",
            cell: row => <LinkText title="View & download document"
                onClick={() => setDocumentData(row)} />
        },

        {
            name: 'Actions',
            sortable: false,
            left: true,
            width: "220px",
            cell: row => <div className="d-flex gap-4">
                {
                    row.kyc_compliant ?
                        <div className="d-flex color-outer-space e-poppins-regular e-font-16 gap-2 align-items-center">
                            <Icon icon="checked" size={20} />
                            ok
                        </div>
                        :
                        <GradientButton label="Check CVL"
                            className="e-huf-action px-2" hide_loader
                            onPress={() => {
                                setOnboardingCheck(1);
                                setCustomerId(row.customer_id)
                            }} />
                }
                <GradientButton label="Upload BSE"
                    className="e-huf-action px-2"
                    hide_loader
                    disabled={row.signup_progress_text === "ADMIN_VERIFICATION" && row.kyc_compliant === true ? false : true}
                    onPress={() => {
                        setOnboardingCheck(2);
                        setCustomerId(row.customer_id);
                    }} />
            </div>
        },
        {
            name: 'Account created on',
            selector: row => row['account_created'],
            sortable: false,
            left: true,
            width: "180px",
            cell: row => <p className="color-outer-space e-poppins-regular e-font-16 mb-0">{row['account_created'] ? row.account_created_on : "-"}</p>
        },

        {
            name: '',
            sortable: false,
            left: true,
            width: "320px",
            omit: selectedType === 1 ? false : true,
            cell: row => <div className="d-flex gap-2">
                <GradientButton label="Reject Partial"
                    className="e-huf-action px-2" hide_loader
                    disabled={(row.signup_progress_text === "ADMIN_VERIFICATION") ? false : true}
                    //  disabled={row.cvl ? false : true}
                    onPress={() => {
                        setOnboardingCheck(3);
                        setCustomerId(row.customer_id)
                    }} />
                <GradientButton label="Reject Complete"
                    className="e-huf-action px-2"
                    hide_loader
                    disabled={(row.signup_progress_text === "ADMIN_VERIFICATION") ? false : true}
                    onPress={() => {
                        setOnboardingCheck(4);
                        setCustomerId(row.customer_id);
                    }} />
            </div>
        },



    ];


    const _kycFilterData = () => {
        const url = "onboarding/kyc/filter-data";
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                let kyc_flow_types = response.data.kyc_types[`non-individual`].filter((item) => (item.id === 1)).map((item) => {
                    return ({
                        type: item.name,
                        id: item.id
                    })
                })
                setKycTypes(kyc_flow_types);
                setSelectedType(kyc_flow_types[0].id);
                setFilterLoader(true);
            }
        })
    }

    // API - list onboardiing
    const _listOnboardingTypes = () => {
        setApiLoader(true);
        const url = "onboarding/kyc/list-other-types";
        const request = {
            "query": "",
            "filter_id": 0,
            "page_num": pageNumber,
            "kyc_flow_type": selectedType,
            "page_size": 20,
            "start_date": null,
            "end_date": null,
            "start_time": null,
            "end_time": null
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setOnboardingData(response.data);
                let total_pages = Math.ceil(response.data.number_of_records / response.data.page_size);
                setTotalPages(total_pages);
            } else {
                setOnboardingData({})
            }
            setApiLoader(false)
        })
    }


    const _checkDoc = async () => {
        if (onboardingCheck === 1 || onboardingCheck === 2) {
            setBtnLoader(true);
            let valid = false
            try {
                const url = onboardingCheck === 1 ? "onboarding/kyc/check" : "onboarding/kyc/upload-bse";
                const request = {
                    customer_id: customerId
                }
                const response = await APIService(true, url, request);
                toast.dismiss();

                if (response.status_code === 200) {
                    setStatusData(response.data);
                    valid = true;
                } else {
                    valid = false
                    toast.error(response.message)
                }
                setBtnLoader(false);
                return valid
            } catch (err) {
                valid = false

            }
        } else {
            setBtnLoader(true);
            let valid = false
            try {
                const url = onboardingCheck === 3 ? "onboarding/kyc/reject" : "onboarding/kyc/reject";
                const request = {
                    customer_id: customerId,
                    partial: onboardingCheck === 3 ? true : false
                }
                const response = await APIService(true, url, request);
                toast.dismiss();

                if (response.status_code === 200) {
                    toast.success(onboardingCheck === 3 ? "Rejected partially" : "Rejected completely", {
                        type: "success"
                    })
                    valid = true;
                    setOnboardingCheck(null);
                    _listOnboardingTypes();
                } else {
                    valid = false
                    toast.error(response.message)
                }
                setBtnLoader(false);
                return valid
            } catch (err) {
                valid = false

            }
        }
    }

    return (
        <Fragment>
            <NavigationHeader type={1}
                title="Manage Onboarding" />
            <div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-32px-top min-height-100vh">
                <CustomTab data={kycTypes}
                    index={selectedType}
                    type={2}
                    onSelectTab={(tab) => setSelectedType(tab)} />
                {/* <p class="color-black e-poppins-medium e-font-20-sm-18 line-height-32px mt-sm-4 mt-3 mb-0">Manage HUF Investment</p> */}
                <div className="row">
                    {
                        apiLoader === true ?
                            <div className="col-12 h-60vh">
                                <CustomLoader />
                            </div>
                            :
                            (onboardingData?.data ?? []).length !== 0 ?
                                <div className="col-12 px-0 position-relative">
                                    <DataTableContainer columns={ONBOARDING_COLUMNS}
                                        data={onboardingData.data}
                                        selectableRows={false}
                                        pagination={true}
                                        customStyles={TABLE_STYLE}
                                        paginationTotalRows={totalPages}
                                        paginationComponentOptions={{
                                            rowsPerPageText: `${onboardingData.page} | Total records: ${onboardingData.number_of_records}`,
                                        }}
                                        onChangeRowsPerPage={(e) => {
                                            setPageSize(e);
                                            setPageNumber(1);
                                        }}
                                        paginationPerPage={pageSize}
                                        rowClick={(row) => {
                                            _navigateToDetail(row.customer_id)
                                        }} />
                                    <div className={`d-flex justify-content-end align-items-center mt-3 position-absolute bottom-16px right-24 w-max-content`}>
                                        <Icon icon="pagination-previous" width="24px" height="24px"
                                            className={pageNumber === 1 ? 'pointer-events-none opacity-4 mx-3' : 'mx-3 cursor-pointer'}
                                            onClick={_previousPage} />
                                        <Icon icon="pagination-next" width="24px" height="24px"
                                            className={pageNumber === totalPages ? 'ms-1 pointer-events-none opacity-4' : 'ms-1 cursor-pointer'}
                                            onClick={_nextPage} />
                                    </div>
                                </div>
                                :
                                <EmptyScreen title="No data!" />
                    }
                </div>
                {
                    onboardingCheck !== null && <OnboardingCheckModal title={onboardingCheck === 1 ? "Check CVL" : onboardingCheck === 2 ? "Uplaod to BSE" : onboardingCheck === 3 ? "Reject partially" : "Reject completely"}
                        description={"Are you sure , you want to continue?"}
                        check={_checkDoc}
                        loader={btnLoader}
                        type={onboardingCheck}
                        statusData={statusData}
                        updateList={_listOnboardingTypes}
                        close={() => {
                            setOnboardingCheck(null);
                            setCustomerId(null);
                        }} />
                }
                {
                    documentData !== null && <ViewDocModal data={documentData}
                        type={selectedType}
                        close={() => setDocumentData(null)} />
                }

            </div>
        </Fragment>
    )
}

export default HUFList